import { connect } from '@atlassian/jira-react-redux';
import { setExpandedCardGroups, collapseAllCardGroups } from '../../../state/actions/card-list';
import { togglePanel } from '../../../state/actions/panels';
import { getIsCompanyManaged, getRapidViewId } from '../../../state/selectors/app';
import { getShowEpicAsPanel } from '../../../state/selectors/config';
import { isBacklogWithSprints as isBacklogWithSprintsSelector } from '../../../state/selectors/sprints';
import { isVersionsFeatureEnabled } from '../../../state/selectors/version';
import type { State } from '../../../state/types';
import Operations from '../extension';
import FilterBar from './filter-bar';
import { ControlsBar } from './view';

export default connect(
	(state: State) => ({
		rapidViewId: Number(getRapidViewId(state)),
		isBacklogWithSprints: isBacklogWithSprintsSelector(state),
		FilterBar,
		Operations,
		isClassic: getIsCompanyManaged(state),
		showEpicAsPanel: getShowEpicAsPanel(state),
		isVersionsEnabled: isVersionsFeatureEnabled(state),
	}),
	{
		onTogglePanel: togglePanel,
		onSubtasksExpandAll: setExpandedCardGroups,
		onSubtasksCollapseAll: collapseAllCardGroups,
	},
)(ControlsBar);
